import { Alert } from '@mui/material';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React from 'react';

import { useGlobalContext } from '@/shared/providers';

const CustomSnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { footerHeight } = useGlobalContext();

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      const snackbarContainer = document.querySelector('.notistack-SnackbarContainer');
      if (snackbarContainer) {
        (snackbarContainer as HTMLElement).style.marginBottom = `${footerHeight}px`;
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, [footerHeight]);

  const CustomAlert = React.forwardRef<HTMLDivElement, any>((props, ref) => {
    const { closeSnackbar } = useSnackbar();
    return (
      <Alert ref={ref}
             severity={props.variant}
             variant='standard'
             sx={{ width: '100%' }}
             onClose={() => closeSnackbar(props.id)}
      >
        {props.message}
      </Alert>
    );
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      Components={{
        info: CustomAlert,
        success: CustomAlert,
        warning: CustomAlert,
        error: CustomAlert,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default CustomSnackbarProvider;